import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'

/**
 *  用户登录
 * @param option.username 用户名
 * @param option.password 密码
 * @returns {Promise<void>}
 */
const login = async (option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v1/auth/login`, option)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 退出登录
 *
 */
const exitLogin = async (option) => {

}
/**
 * 修改用户昵称
 * @param option.nickname 新昵称
 * @returns {Promise<void>}
 */
const updataNickName = async (option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.put('/api/v1/me', option)
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 *  修改用户密码
 * @param  options.oldPassword 旧密码
 * @param  options.newPassword 新密码
 * @returns {Promise<void>}
 */
const updatePassword = async (option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post('/api/v1/me/password', option)
    .then(res => {
      AuiToast.hide()
      return res
    })
}

const user = {
  login,
  exitLogin,
  updataNickName,
  updatePassword
}
export default user
